import { z } from "zod";
export const EmailInput = z.object({
    email: z
        .email()
        .max(254)
        .transform((s) => s.toLowerCase()),
});
export const Password = z.string().min(12).max(128);
export const SecondFactor = z.string().regex(/^(?:\d{6}|[a-f0-9]{24})$/);
export const LoginInput = EmailInput.extend({
    password: z.string().min(8).max(128),
    code: SecondFactor.optional(),
});
export const RegisterInput = EmailInput.extend({
    password: Password,
    nick: z.string().trim().min(2).max(32),
});
export const TokenInput = z.object({ token: z.string().regex(/^[a-f0-9]{64}$/) });
export const ResetPasswordInput = TokenInput.extend({ password: Password, code: SecondFactor.optional() });
export const PasswordProof = z.object({
    password: z.string().min(8).max(128),
    code: SecondFactor.optional(),
});
export const TotpInput = z.object({ code: z.string().regex(/^\d{6}$/) });
export const AuthResponse = z.object({
    accessToken: z.string(),
    user: z.object({ id: z.string(), nick: z.string(), guest: z.boolean() }),
});
export const SuccessResponse = z.object({ ok: z.literal(true) });
//# sourceMappingURL=auth.js.map